const TAB_COUNT_KEY = 'tabCount';
const SESSION_KEY = 'tabInitialized';
const LAST_CLOSED_KEY = 'lastTabClosedAt';

let isNewTab = false;

// Check if this is a new tab (not a reload)
if (!sessionStorage.getItem(SESSION_KEY)) {
  sessionStorage.setItem(SESSION_KEY, 'true');
  isNewTab = true;

  const currentCount = parseInt(localStorage.getItem(TAB_COUNT_KEY) || '0', 10);
  const newCount = currentCount + 1;
  localStorage.setItem(TAB_COUNT_KEY, newCount.toString());

  // If tab count was 0 and it's now 1 → this is the first tab after all others were closed
  const lastClosedAt = parseInt(localStorage.getItem(LAST_CLOSED_KEY) || '0', 10);
  const now = Date.now();
  if (currentCount === 0 && now - lastClosedAt > 100) {
    // All tabs were previously closed → clear localStorage
    console.log('[TabTracker] All previous tabs closed. Clearing localStorage now.');
    localStorage.clear();
    localStorage.setItem(TAB_COUNT_KEY, '1'); // Reset tabCount
  }
}

// On unload: decrease tab count
window.addEventListener('unload', () => {
  if (!isNewTab) return;

  const currentCount = parseInt(localStorage.getItem(TAB_COUNT_KEY) || '1', 10);
  const newCount = Math.max(currentCount - 1, 0);
  localStorage.setItem(TAB_COUNT_KEY, newCount.toString());

  if (newCount === 0) {
    // Record timestamp when last tab closed
    localStorage.setItem(LAST_CLOSED_KEY, Date.now().toString());
    // Don't clear here — the next tab that opens will handle it
    console.log('[TabTracker] Last tab closed. Marked time.');
  }
});
